// Single source of truth for the customer-facing support contact details.
// Anything user-visible (contact page, footer, order help blocks, policy pages)
// should read from here so the number only ever changes in one place.

export const SUPPORT_PHONE = '+91 22 6985 1705';

// E.164, no spaces — dialable from tel: links on mobile.
export const SUPPORT_PHONE_HREF = 'tel:+912269851705';

export const SUPPORT_EMAIL = 'support@clearway-mobility.com';
